import { isRebranded } from '../rebrandingFeatureFlag';

let isReskinned = isRebranded;

const getIsReskinned = () => isReskinned;

const setIsReskinned = (reskin: boolean) => {
  isReskinned = reskin;
};

export { setIsReskinned, getIsReskinned };
